import * as React from "react";
import { forwardRef } from "react";
const SvgSortUp = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, viewBox: "0 0 32 32", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M25 22c0 .625-.51 1.143-1.125 1.143H8.125a1.142 1.142 0 0 1-.791-1.947l7.875-8a1.11 1.11 0 0 1 .791-.339c.3 0 .58.125.791.339l7.875 8c.211.214.334.5.334.804Z" }));
const ForwardRef = forwardRef(SvgSortUp);
export default ForwardRef;
